import { gql } from '@apollo/client';

export const CLUB_REVIEWS = gql`
  query clubReviews($input: ClubCommentSearchInput, $page: Int) {
    clubComments(input: $input, page: $page) {
      paginatorInfo {
        count
        currentPage
        lastPage
      }
      summary {
        average_grade
        unread_total
        five
        four
        three
        two
        one
      }
      data {
        id
        text
        author {
          uuid
          nickname
          phone
        }
        created_at
        host_alias
        host_group_name
        grade
        is_read
        request_contact
        request_contact_info
        tips
        worker_name
      }
    }
  }
`;

export const READ_CLUB_REVIEW = gql`
  mutation readClubComment($id: Int!) {
    readClubComment(id: $id) {
      id
      is_read
    }
  }
`;

export const READ_ALL_CLUB_REVIEWS = gql`
  mutation readAllClubComments {
    readAllClubComments
  }
`;

export const IS_READ_FRAGMENT = gql`
  fragment isRead on ClubComment {
    is_read
  }
`;

export const REVIEWS_COUNT = gql`
  query clubCommentsCount {
    clubComments {
      summary {
        unread_total
      }
    }
  }
`;
